<template>  
<div  ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">        
    <template v-if="mission && mission.dataSimulation && mission.dataSimulation.length > 0">
      <v-layout row justify-center style="flex:0 0 auto;">
        <v-btn small :color="dataLimitMode === dataLimit?'secondary':'primary'" v-for="dataLimitMode in $options.dataLimitModes" :key="dataLimitMode"              
             @click="$store.myActions.UI_SET_GRA_DATA({uiid,name:'dataLimit',value:dataLimitMode})" >{{$t(`Pilot.Graphics.LimitData${dataLimitMode}`)}}</v-btn>        
      </v-layout>
      <div style="flex:1 0 auto;position:relative;" class="mr-4">
        <div class="scrollable-container" style="padding-right: 0px;left: 0px;">
   <Responsive :breakpoints="{
    small: el => el.width <= 420
  }">
  <v-layout slot-scope="el" @mousedown.prevent.stop="stopClick"  ref="detail" mt-2  row wrap>          
    <v-flex v-for="graph in simuGraphs" style="position:relative;" class="inline-block px-2" :class="{sm12:el.is.small,sm6:!el.is.small}" :key="graph.id">            
        <v-btn icon @click="selectGraph(graph)" small style="position:absolute;top:-5px;left:-5px;z-index:1"><v-icon>mdi-magnify-plus</v-icon></v-btn>
        <v-flex class="inline-block xs12 w-full text-xs-center body-2 mt-1" :key="graph.name">{{tryTranslate(graph.name)}}</v-flex>                
        <div class="graph mb-2" >
          <mission-scatter-plot  v-if="mission" 
              :colorOffset="1"
              :sciGraph="false"             
              :simuGraph="true"  
              :pointSize="1" 
              :abscisseVariable="graph.abscisse"
              :ordonneeVariable="graph.ordonnee"
              :colorVariable="graph.color"
              :uiid="uiid" 
              :prefixe="graph.id"
              :allowClick="true"
              :allowZoom="false"                        
              :marginWidth="5"   
              :offsetLegendX="10"
              :offsetLegendY="5"  
              :colorGradientWidth="5"            
              :offsetLegendColor="5"              
              :xTicks="graph.xTicks"
              :yTicks="5"
              :colorTicks="5"      
              :useCacheImg="false"
              :redraw="componentRefresh"              
              :dataLimit="dataLimit"
              :mission="mission"
              :tabState="tabState"
              />        
        </div>
      </v-flex>      
  </v-layout>     
    </Responsive> </div>   </div>
     <mission-graph-hover-data
        :uiid="uiid" 
        :sciGraph="false"
        :simuGraph="true"
        prefixe="hoverdata_simu"              
        :dataLimit="dataLimit"
        :mission="mission"
        :tabState="tabState"
     />    
    </template>
    <template v-else>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Graphics.NoDataAvailable')}}</span>
    </template>        
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'  
  import {zoomIdentity} from 'd3'  
  import MissionScatterPlot from '@/components/charts/MissionScatterPlot'  
  import { dataLimitMode } from '@/models/ui/GraphUiState'  
  import MissionGraphHoverData from '@/components/mission/MissionGraphHoverData.vue'
  import { AloMission } from '@/models/alo/AloMission'

  export default {
    components:{MissionScatterPlot,MissionGraphHoverData},
    props:  {
      isleft:Boolean,
      uiid:{
          type: String,
          required: true
      },
      mission:{
        type:AloMission,
        required:true
      },
      tabState:{
        required:true
      }
   },      
   name: 'MissionEndSimulationSinglePlotsListGen',        
   mounted() {         
   },       
   computed: {
       ...mapGetters([          
         'uistatebyuiid'
      ]),           
      leftPanelWidth(){
        return this.tabState.leftPanelWidth
      },
      allGraphUiState() {                
        return this.uistatebyuiid(this.uiid)
      },                       
      dataLimit(){
        return this.allGraphUiState.dataLimit
      },
      componentRefresh() {
        return this.allGraphUiState && this.allGraphUiState.refresh 
      },          
      simuGraphs() {
        return this.mission.simuPlotVariables.filter(v => v.autoPlot).map(currentValue => { return {
          id: currentValue.variable,
          name : currentValue.name,
          abscisse : this.mission.xSimuScatterVariable,
          ordonnee : currentValue.variable,
          color : "None",
          transform : zoomIdentity,
          size : 2,
          xTicks: 3,
          dataLimit: this.dataLimit
        }})
      }
    },    
    created() {
      this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(this.uiid)      
      this.$options.dataLimitModes = [dataLimitMode.LAST_12H,dataLimitMode.LAST_24H,dataLimitMode.ALL]
      this.$store.myActions.UI_SET_GRA_DATA({uiid:this.uiid,name:'dataLimit',value:dataLimitMode.ALL})   
    },
    watch : {
      uiid(newValue) {
        this.$store.myActions.UI_ENSURE_ALL_GRA_STATE(newValue)
      },
      mission(){
        this.allGraphUiState.refresh = !this.allGraphUiState.refresh
      },
      leftPanelWidth(newValue) {
        this.allGraphUiState.refresh = !this.allGraphUiState.refresh
      }      
    },
    beforeDestroy () {      
    },
    methods: {            
      tryTranslate(key) {        
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      selectGraph(graph) {   
        this.$emit("selectGraph",graph)    
      },   
      stopClick(){

      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .graph{
    border:1px solid #ddd;
    box-sizing: content-box;
    width:100%;
    height:175px;
    position:relative;
    cursor: pointer;
  }
</style>
